import { render, staticRenderFns } from "./LandingHeroSection.vue?vue&type=template&id=01223e29&scoped=true&"
import script from "./LandingHeroSection.vue?vue&type=script&lang=js&"
export * from "./LandingHeroSection.vue?vue&type=script&lang=js&"
import style0 from "./LandingHeroSection.vue?vue&type=style&index=0&id=01223e29&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01223e29",
  null
  
)

export default component.exports